import { useEffect } from 'react';
import { useBilling } from '../contexts/BillingContext.js';

/**
 * Re-read entitlement whenever a different document opens.
 *
 * The first upload in a meeting is what makes its host known, and what starts
 * the uploading tenant's trial. Without this, a guest who opened the panel
 * before the host uploaded would never be told they are a guest, and a host's
 * new trial would stay invisible until the window next regained focus.
 *
 * Used by both SidePanel and MeetingStage — keep it in one place so the two
 * surfaces cannot drift apart.
 */
export function useBillingRefreshOnDocument(documentId: string | undefined): void {
  const { refresh } = useBilling();
  useEffect(() => {
    if (documentId) void refresh();
    // refresh is deliberately left out: its identity changes when the auth
    // token arrives, and that must not count as a document opening.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentId]);
}
